import React from "react";
import { heroProof } from "../../../data/portfolioData";
import { CircleMark } from "../../../components/Sketch";

export const HeroStats = () => {
  return (
    <ul className="hero-proof hero-enter hero-enter-later" aria-label="Results from recent projects">
      {heroProof.map((item) => (
        <li key={item.lead} className="hero-proof-item">
          <span className="hero-proof-value">
            {item.value}
            <CircleMark />
          </span>
          <span className="hero-proof-lead">{item.lead}</span>
          <span className="hero-proof-text">{item.text}</span>
        </li>
      ))}
    </ul>
  );
};
